'use strict';

// #SNOT
// Not SFRA 6x script upgrade compatible. Selective changes applied.
// Script has differences #CDIFF #MONITOR BS <> GG <> PF <> SN <> FM
// Current version is BS-based with delta sync from other site-specific versions.

// eslint-disable space-before-function-paren
// eslint-disable-next-line no-unused-vars

var base = require('theme/js/product/base');
var detail = require('base/product/detail');
var util = require('improove/util/util');
var klarnaInstantShopping = require('theme/js/product/klarna/instantShopping');

import FeatureFlagRegistrar from 'shared/js/featureFlagRegistrar';

detail.initProductCarousel = function () {
    $(document).ready(function () {
        $('.slick-product-carousel .slick-item').removeClass('hidden');

        $('.slick-product-carousel.mobile').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: "<button class='icon-arrow-left-right'></button>",
            nextArrow: "<button class='icon-arrow-left-right right'></button>",
            dots: true
        });

        $('.slick-product-carousel.desktop').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: "<button class='icon-arrow-left-right'></button>",
            nextArrow: "<button class='icon-arrow-left-right right'></button>"
        });

        $('.product-swatch-images .swatch').click(function () {
            if (!$(this).hasClass('active')) {
                $(this).siblings('.active').removeClass('active');
                $(this).addClass('active');

                $('.slick-product-carousel.desktop').slick('slickGoTo', ($(this).index()), true);
            }
        });

        $('.slick-product-carousel.desktop').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var productSwatchImages = $('.product-swatch-images .swatch');
            productSwatchImages.siblings('.active').removeClass('active');
            productSwatchImages.eq(nextSlide).addClass('active');
        });
    });
};

detail.togglePopup = function () {
    $('.product-outofstock-popup-close, .product-outofstock-popup-cancel').click(function (e) {
        e.preventDefault();
        $('.product-outofstock-popup__container').addClass('hide');
    });

    $('button.notify-me').click(function () {
        $('.product-outofstock-popup__container').removeClass('hide');
    });
};

detail.customProductSetVariantSelection = function () {
    $(document).on('click', '.set-product-dropdown .set-product-item', function (e) {
        e.preventDefault();
        $(this).closest('.dropdown').removeClass('active');
        if ($(this).attr('disabled') || $(this).children('.selected').length > 0) {
            return;
        }
        var setProductDropdown = $(this).closest('.dropdown');
        var setProductHeader = setProductDropdown.find('.dropdown-header');
        setProductHeader.attr('data-pid', $(this).attr('data-pid'));
        setProductHeader.attr('data-availability', $(this).attr('data-availability'));
        setProductHeader.find('.title').html($(this).text());

        if ($('.bundle-item').length) {
            var bundleItem = setProductDropdown.find('.product-id');
            bundleItem.text($(this).attr('data-pid'));
        }

        var disableBuyButton = false;
        var $productContainer = $(this).closest('.product-detail');
        $productContainer.find('.dropdown-header').each(function () {
            if ($(this).attr('data-availability') !== 'true') {
                disableBuyButton = true;
            }
        });

        handleOutOfStock(disableBuyButton, $productContainer);
    });
};

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} isOutOfStock - is product out of stock
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function handleOutOfStock(isOutOfStock, $productContainer) {
    var quantityInput = $productContainer.find('.quantity-select');
    var addToCart = $productContainer.find('.add-to-cart');
    var notifyMe = $productContainer.find('.notify-me');
    var noInventory = $productContainer.find('.variation-dropdown .dropdown-header .title .no-inventory');
    var variationDropdownRectangle = $productContainer.find('.variation-dropdown-rectangle');
    var productOutofstockDisclaimer = $productContainer.find('.product-outofstock-disclaimer');

    if (isOutOfStock) {
        addToCart.addClass('hide');
        addToCart.attr('disabled', true);
        notifyMe.removeClass('hide');
        noInventory.removeClass('hide');
        variationDropdownRectangle.addClass('greyed-out');
        quantityInput.val('-');
        quantityInput.attr('disabled', true);
        quantityInput.siblings('.increase-quantity').addClass('icon--disabled');
        quantityInput.siblings('.decrease-quantity').addClass('icon--disabled');
        productOutofstockDisclaimer.removeClass('hide');
    } else {
        addToCart.removeClass('hide');
        addToCart.removeAttr('disabled');
        notifyMe.addClass('hide');
        noInventory.addClass('hide');
        variationDropdownRectangle.removeClass('greyed-out');
        quantityInput.val(1);
        quantityInput.removeAttr('disabled');
        quantityInput.siblings('.increase-quantity').removeClass('icon--disabled');
        quantityInput.siblings('.decrease-quantity').addClass('icon--disabled');
        productOutofstockDisclaimer.addClass('hide');
    }
}

// #ADDIN
$('[data-go-back]').click(function (event) {
    event.preventDefault();
    history.back();
});

function showAfterSubmitPopup() {
    $('.product-outofstock-popup-before-submit').addClass('hide');
    $('.product-outofstock-popup-after-submit').removeClass('hide');
}

function showBeforeSubmitPopup() {
    $('.product-outofstock-popup-before-submit').removeClass('hide');
    $('.product-outofstock-popup-after-submit').addClass('hide');
}

$('.product-outofstock-popup-close-link, .product-outofstock-popup-close').on('click', function (e) {
    e.preventDefault();
    $('.product-outofstock-popup__container').addClass('hide');
    showBeforeSubmitPopup();
});

/**
 * @private
 * @function
 * @description Submit an email on Back in Stock Popup
 */

function submitBackInStock() {
    var emailInput = $('.product-outofstock-popup-email-form-input').val();
    var pid = $('.product-outofstock-popup-pid-form-input').val();

    var regExp = /^[a-zA-Z0-9]*([\w+-]+\.)*[\w+-]+@[a-zA-Z0-9]([\w-]+\.)*[a-zA-Z]{2,6}$/;
    var error = '';

    if (emailInput.length == 0) {
        error = 'this field is required';
    } else if (!emailInput.match(regExp)) {
        error = 'please enter a valid email';
    }
    if (!error && error.length == 0) {
        grecaptcha.ready(function () { // eslint-disable-line
            grecaptcha.execute($('.product-outofstock-popup-submit').attr('data-recaptcha-site-key'), { action: 'backinstock' }).then(function (token) { // eslint-disable-line
                var productType = $('.product-outofstock-popup-pid-form-input').attr('data-product-type');

                var outOfStockBundledProducts = [];
                var outOfStockSetProducts = [];
                if (productType == 'bundle') {
                    var bundleAvailable = $('.product-availability').attr('data-available');
                    if (bundleAvailable != 'false') {
                        var bundleDD = $('.set-product-dropdown .dropdown-header');
                        outOfStockBundledProducts = [];
                        if (bundleDD && bundleDD.length > 0) {
                            bundleDD.each(function (index, bundledProduct) {
                                var bundledPid = $(bundledProduct).data('pid');
                                if ($(bundledProduct).data('availability') === false && !outOfStockBundledProducts.includes(bundledPid)) {
                                    outOfStockBundledProducts.push(String(bundledPid));
                                }
                            });
                        }
                    }
                } else {
                    var setProductDD = $('.set-product-dropdown .dropdown-header');
                    outOfStockSetProducts = [];
                    if (setProductDD && setProductDD.length > 0) {
                        setProductDD.each(function (index, setProduct) {
                            var setPid = $(setProduct).data('pid');
                            if ($(setProduct).data('availability') === false && !outOfStockSetProducts.includes(setPid)) {
                                outOfStockSetProducts.push(setPid);
                            }
                        });
                    }
                }

                var params = {
                    email: emailInput,
                    pid: pid,
                    token: token,
                    action: 'backinstock',
                    setPids: outOfStockSetProducts.length > 0 ? JSON.stringify(outOfStockSetProducts) : null,
                    bundlePids: outOfStockBundledProducts.length > 0 ? JSON.stringify(outOfStockBundledProducts) : null
                };

                var url = $('.product-outofstock-popup-submit').data('url');

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: params,
                    error: function () {
                        window.MessagesMgr.error('Subscription failed, please try again later');
                    },
                    success: function (data) {
                        if (data && data.status === 'error') {
                            window.MessagesMgr.error(data.message || 'Subscription failed, please try again later');
                            return;
                        }
                        $('.product-outofstock-popup-email-submit').html(emailInput);
                        showAfterSubmitPopup();
                        $('.back-in-stock__success').removeClass('hide');
                    }
                });
            });
        });
    } else {
    // Email is empty or not valid - Show error
        $('.back-in-stock__error').removeClass('hide');
        $('.back-in-stock__error').text(error);
    }
}

$('.product-outofstock-popup-submit').click(function () {
    submitBackInStock();
});

$('[data-sibling-image]').on('mouseover', function () {
    var siblingColor = $(this).find('[data-sibling-color]').data('sibling-color');
    $('[data-color-value]').text(siblingColor);
    $('[data-sibling-image]').removeClass('active');
    $(this).addClass('active');
});

// #CDIFF DONE There was pushNumOfReviews function for yotpo.

/**
 * updates the sibling color when sibling thumbnail is hovered
 * @param {string} selectedValueUrl - the Url for the hovered sibling
 */
function updateSiblingColorValue(siblingUrl) {
    $.ajax({
        url: siblingUrl,
        method: 'GET',
        success: function (data) {
            $('[data-color-value]').text(data.siblingColor);
        }
    });
}

// Display Product Sibling Name on hover
$('[data-sibling-image]').on('mouseover', function () {
    var siblingUrl = $(this).attr('data-action');
    updateSiblingColorValue(siblingUrl);
    $('[data-sibling-image]').removeClass('active');
    $(this).addClass('active');
});

// Init Product Sibling Horizontal scroll

var scrollDivideBy = 5;

if (util.getScreenSize() === 'small') {
    if ($('.product-tile-wrapper').length < 4) {
        $('[data-arrow-sibling]').css('display', 'none');
    }
    scrollDivideBy = 3;
} else if (util.getScreenSize() !== 'small') {
    if ($('.product-tile-wrapper').length < 6) {
        $('[data-arrow-sibling]').css('display', 'none');
    }
}


var siblingsWrapper = $('.product-siblings'),
    scrollRight,
    scrollLeft;

$('[data-arrow-sibling]').on('click', function (e) {
    e.stopPropagation();

    if ($(this).hasClass('arrow-right')) {
        scrollLeft = ((siblingsWrapper.width() / scrollDivideBy)) + siblingsWrapper.scrollLeft();
        siblingsWrapper.animate({
            scrollLeft: scrollLeft,
        });
    } else {
        scrollRight = ((siblingsWrapper.width() / scrollDivideBy)) - siblingsWrapper.scrollLeft();
        siblingsWrapper.animate({
            scrollLeft: -scrollRight,
        });
    }
});

function klarnaInstantShoppingButton() {
    klarnaInstantShopping.init();
    if (typeof klarnaInstantShopping.loadCallback === 'function') {
        klarnaInstantShopping.loadCallback();
    }
}

// #ADDIN #CDIFF #DONE BS <> SN
if (!FeatureFlagRegistrar.isSite('SN')) {
    function showReviewTab() { // eslint-disable-line no-inner-declarations
        $('#product-tabs .item').removeClass('active');
        $('.reviews').addClass('active');
        $('html, body').animate({
            scrollTop: $('.description-and-detail').offset().top
        }, 0);
    }


    // #ADDIN #CDIFF #DONE BS <> SN
    $(document).ready(function () {
        $('.show-review-tab').on('click', function () {
            showReviewTab();
        });

        $('.show-information-tab').on('click', function () {
            $('#product-tabs .item').removeClass('active');
            $('.information').addClass('active');
            $('.information-item').addClass('active');
            $('.information').trigger('focus');
            $('html, body').animate({
                scrollTop: $('.long-description.columns').offset().top
            }, 0);
        });
        var url = window.location.href;

        if (FeatureFlagRegistrar.get('integration.gmf.active')) {
            if (url.indexOf('gmf-comment-section') > -1) {
                setTimeout(function () {
                    showReviewTab();
                }, 1500);
            }
        }
    });
}

function openInformationTab() {
    $('.product-short-description .read-more').on('click', function () {
        $('#product-tabs .item').removeClass('active');
        $('#product-tabs .tabs-header .item.information').addClass('active');
        $('#product-tabs .tabs-content .item.columns').addClass('active');
    });
}

// #CDIFF #MONITOR SN Lacks several functions present in BS
// Do not export addToCart since it's handled with "theme/js/product/quickView" registered callback.
// detail.addToCart = base.addToCart;
detail.openInformationTab = openInformationTab; // #UNIQ-DETAIL
detail.getPidValue = base.getPidValue; // #UNIQ-DETAIL

// Explicitly remove the SFRA native "addToCart" function. It cannot work correctly, because there is a custom version
// defined in custom (overridden) scripts.
// Otherwise, it causes duplicated "add to cart" QTY increasing + with missed part of the custom logic.
delete detail.addToCart;

// detail.availability = base.availability;
if (FeatureFlagRegistrar.get('checkout.klarna.active')
    && FeatureFlagRegistrar.get('checkout.klarna.instantshopping.active')) {
    // #FIXME #TBD Should it be really "klarnaInstantShoppingButton()" and not "klarnaInstantShoppingButton"?
    // With new Klarna instant shopping button would be replaced with another solution.
    detail.klarnaInstantShopping = klarnaInstantShoppingButton();
}

module.exports = detail;
